import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useAppState } from "@/store/useApp";
import { Agent } from "@/types/agent";
import claireAvatar from "@/assets/agents/agent.jpeg";
import userAvatar from "@/assets/agents/user.jpeg";

interface AgentAvatarProps {
  agent?: Agent;
  agentId?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-12 w-12",
};

export const AgentAvatar = ({
  agent: providedAgent,
  agentId,
  className = "",
  size = "md",
}: AgentAvatarProps) => {
  const agents = useAppState((state) => state.agents || []);
  
  // Find agent by ID if not provided directly
  const agent = providedAgent || (agentId ? agents.find((a) => a.id === agentId) : null);
  
  // Map avatar property to image source
  const getAvatarSrc = (avatar?: "claire" | "user") => {
    if (avatar === "user") return userAvatar;
    if (avatar === "claire") return claireAvatar;
    return claireAvatar; // Default to claire
  };
  
  const avatarSrc = getAvatarSrc(agent?.avatar);
  const fallbackText = agent?.name.charAt(0).toUpperCase() || "AI";
  const altText = agent?.name || "Agent";
  const sizeClass = sizeMap[size];

  return (
    <Avatar className={`${sizeClass} ${className}`}>
      <AvatarImage src={avatarSrc} alt={altText} />
      <AvatarFallback>{fallbackText}</AvatarFallback>
    </Avatar>
  );
};

